import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import { CalculationComponent } from './calculation.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'calculation',
    component: CalculationComponent,
    future: true,
    data: {
      pageTitle: 'states.calculation.pageTitle',
      scopes: ['calculation:read']
    }
  },
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class CalculationRoutingModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/calculation/calculation.routes.ts